import type { ReactNode } from "react";

/** Outline icon drawn with strokes, as in the prototype's section icons. */
export default function LineIcon({
  children,
  viewBox = "0 0 24 24",
  className,
}: {
  children: ReactNode;
  viewBox?: string;
  className?: string;
}) {
  return (
    <svg
      viewBox={viewBox}
      aria-hidden
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {children}
    </svg>
  );
}
